import { combineReducers } from 'redux'
import { replayReducer, ReplayState } from './replay.reducer'
import { snapshotReducer, SnapshotState } from './snapshot.reducer'

// Root state interface
export interface RootState {
  replay: ReplayState
  snapshot: SnapshotState
  // Add other state interfaces as needed
}

// Root reducer
const rootReducer = combineReducers({
  replay: replayReducer,
  snapshot: snapshotReducer,
  // Add other reducers as needed
})

export default rootReducer

// Export all reducers
export * from './replay.reducer'
export * from './snapshot.reducer'
